import { Families } from '@components/Families';
import { GlobalStyle } from '@components/GlobalStyle';
import { Layout } from '@components/Layout';
import { SEO } from '@components/SEO';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core';
import React from 'react';
import { ThemeProvider } from 'styled-components';

const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#000'
    },
    secondary: {
      main: '#fff'
    }
  }
});

const theme = {
  primary: '#000',
  secondary: '#fff'
}

export default function Index() {
  return (
    <ThemeProvider theme={theme}>
      <MuiThemeProvider theme={muiTheme}>
        <Layout>
          <GlobalStyle />
          <SEO />
          <Families />
        </Layout>
      </MuiThemeProvider>
    </ThemeProvider>
  );
}
